import { yupResolver } from "@hookform/resolvers/yup";
import {
  resetPasswordSchema,
  ResetPasswordSchemaType,
} from "./ResetPasswordSchema";
import styles from "./UpdateLogo.module.css";
import { useForm } from "react-hook-form";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import passwordIcon from "../../../assets/login_password.svg";
import clsx from "clsx";
import { useState } from "react";
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import { resetClientPassword } from "../../../api/auth";
import { useSnackbar } from "../../../context/SnackbarContext";

interface Props {
  onClose: any;
  handleDone: any;
}

const ResetPassword = ({ onClose, handleDone }: Props) => {
  const { register, formState, handleSubmit, reset, setError } =
    useForm<ResetPasswordSchemaType>({
      mode: "onTouched",
      resolver: yupResolver(resetPasswordSchema),
      defaultValues: { oldPassword: "", newPassword: "" },
    });

  const [newVis, setNewVis] = useState(false);
  const [oldVis, setOldVis] = useState(false);

  const handleNewVis = () => {
    setNewVis((prevState) => !prevState);
  };

  const handleOldVis = () => {
    setOldVis((prevState) => !prevState);
  };

  const { showSnackbar } = useSnackbar();

  const handleChangePassword = async (data: ResetPasswordSchemaType) => {
    const resp = await resetClientPassword(data.oldPassword, data.newPassword);

    if (resp?.responseInfo.httpCode === 200) {
      showSnackbar("Changed Password Successfully", "success");
      reset();
      handleDone();
      onClose();
    } else if (resp?.responseInfo.httpCode === 401) {
      setError("oldPassword", {
        message: resp?.responseInfo?.description || "Something went wrong",
      });
    } else {
      showSnackbar(
        resp?.responseInfo?.description || "Something went wrong.",
        "error"
      );
    }
  };

  return (
    <form
      className={styles.rpFormContainer}
      onSubmit={handleSubmit(handleChangePassword)}
    >
      <div className={styles.header}>
        <span className={styles.headerTitle}>Change Password</span>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <TextField
        placeholder="Current Password"
        {...register("oldPassword")}
        fullWidth
        type={oldVis ? "text" : "password"}
        error={!!formState.errors.oldPassword}
        helperText={formState.errors.oldPassword?.message}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img src={passwordIcon} alt="password_icon" />
            </InputAdornment>
          ),
          endAdornment: (
            <IconButton
              onClick={handleOldVis}
              edge="end"
              style={{ marginRight: "4px" }}
            >
              {oldVis ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
      />
      <TextField
        placeholder="New Password"
        fullWidth
        {...register("newPassword")}
        type={newVis ? "text" : "password"}
        error={!!formState.errors.newPassword}
        helperText={formState.errors.newPassword?.message}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img src={passwordIcon} alt="password_icon" />
            </InputAdornment>
          ),
          endAdornment: (
            <IconButton
              onClick={handleNewVis}
              edge="end"
              style={{ marginRight: "4px" }}
            >
              {newVis ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
      />
      <div className={styles.footer}>
        <button
          onClick={onClose}
          className={clsx(styles.cancelBtn, styles.btn)}
        >
          Cancel
        </button>
        <button className={clsx(styles.saveBtn, styles.btn)}>
          Change Password
        </button>
      </div>
    </form>
  );
};

export default ResetPassword;
